module.exports = __webpack_public_path__ + "static/media/FlorianGraf_next.f68793c6.svg";